import { z } from "zod"

export const appSettingKeySchema = z.object({
  key: z.string().min(1).max(150),
})

export const updateAppSettingSchema = z.object({
  value: z.unknown(),
})

export type UpdateAppSettingInput = z.infer<typeof updateAppSettingSchema>
